<cwo-custom-dropdown #dropdown
  [label]="label() ?? _label()"
  [disabled]="disabled()"
  [value]="formatDate(inputDate())"
  [prefixIcon]="calendarIcon"
  [position]="'absolute'"
  [placement]="'below'"
  [required]="stared()"
>
  <ng-template #menu>
    <div class="content-wrapper">
      <ng-container *ngIf="for() === 'ORDERING_CALENDAR' ">
        <cwo-date-time-picker 
          [deferDateInput]="inputDate()"
          [deferredDayTimes]="deferredDayTimes()"
          (defferedDateTimeUpdate)="handleDateChangeFromCalComp($event)" 
          (storeClosedForSelectedDate)="storeClosedForSelectedDate.emit($event)"
        />
      </ng-container>
    </div>
  </ng-template>
</cwo-custom-dropdown>
